<template>
  <v-form
    ref="form"
    v-model="formValid"
    @submit.prevent="save()"
  >
    <page-template>
      <template slot="title">
        <page-title
          :title="$t('app.administrators.form.title')"
          navigate-back-route="Administrators"
        />
      </template>
      <template slot="content">
        <v-container
          class="py-0"
          fluid
          grid-list-sm
        >
          <form-group :title="$t('app.administrators.form.subtitle')">
            <v-flex
              xs12
              lg6
            >
              <v-layout wrap>
                <v-flex
                  xs12
                  md6
                >
                  <input-text
                    v-model="payload.nome"
                    required
                    :rules="[maxLength(50)]"
                    :label="$t('app.administrators.form.name')"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <input-email
                    v-model="payload.email"
                    :label="$t('app.administrators.form.email')"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <input-text
                    v-model="payload.cpfCnpj"
                    mask="###.###.###-##"
                    required
                    :label="$t('app.administrators.form.document')"
                    :disabled="!!entityId"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <input-text
                    v-model="payload.login"
                    required
                    :rules="[maxLength(50)]"
                    :label="$t('app.administrators.form.login')"
                    :disabled="!!entityId"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                />
                <v-flex
                  xs12
                  md6
                >
                  <input-password
                    v-model="payload.senha"
                    :label="$t('app.administrators.form.password')"
                    :rules="passwordConfirmationRules"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                />
                <v-flex
                  xs12
                  md6
                >
                  <p>{{ $t("app.administrators.form.status") }}</p>
                  <input-radio
                    v-model="payload.situacao"
                    :options="statusOptions"
                    row
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                />
              </v-layout>
            </v-flex>
          </form-group>
          <v-divider class="my-4" />
          <v-flex class="py-3 text-xs-right">
            <btn-cancel
              :text="$t('support.components.crudForm.btnCancel')"
              @click="navigateTo('Administrators')"
            />
            <btn-primary
              :text="$t('support.components.crudForm.btnSave')"
              type="submit"
              :loading="loadingForm"
            />
          </v-flex>
        </v-container>
      </template>
    </page-template>
  </v-form>
</template>

<script>
import FormGroup from 'Support/layout/FormGroup.vue';
import RulesMixin from 'Support/mixins/rules-mixin';
import AdministratorsRequest from 'Domain/administrators/AdministratorsRequest';
import InputText from 'Support/components/inputs/InputText.vue';
import InputEmail from 'Support/components/inputs/InputEmail.vue';
import InputRadio from 'Support/components/inputs/InputRadio.vue';
import InputPassword from 'Support/components/inputs/InputPassword.vue';
import PageTemplate from 'Support/layout/PageTemplate.vue';
import PageTitle from 'Support/layout/PageTitle.vue';
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';
import BtnCancel from 'Support/components/buttons/BtnCancel.vue';
import FormMixin from 'Support/components/crud/form-mixin';
import RouterMixin from 'Support/mixins/router-mixin';
import NotificationMixin from 'Support/mixins/notification-mixin';

export default {
  name: 'AdministratorsForm',
  components: {
    FormGroup,
    InputPassword,
    InputRadio,
    InputEmail,
    InputText,
    PageTemplate,
    PageTitle,
    BtnCancel,
    BtnPrimary,
  },
  mixins: [RulesMixin, FormMixin, RouterMixin, NotificationMixin],
  data: () => ({
    requestClass: AdministratorsRequest,
    navigateToPageAfterSave: 'Administrators',
    payload: {
      nome: '',
      cpfCnpj: '',
      email: '',
      login: '',
      situacao: '',
      senha: '',
    },
    statusOptions: [
      {
        label: 'Ativo',
        value: 'ATIVO',
      },
      {
        label: 'Inativo',
        value: 'INATIVO',
      },
    ],
  }),
  computed: {
    passwordConfirmationRules() {
      return [
        this.minLength(8),
        this.maxLength(20),
      ];
    },
  },
  methods: {
    setEntityData(data) {
      this.payload.nome = data.nome;
      this.payload.cpfCnpj = data.cpfCnpj;
      this.payload.email = data.email;
      this.payload.login = data.login;
      this.payload.situacao = data.situacao;
      this.payload.senha = data.senha;
    },
  },
};
</script>
